import * as decode from 'jwt-decode';

export default class Auth {
    public setToken(token: string) {
        localStorage.setItem('id_token', token);
    }
    
    public setOnlineToken(token: string) {
        localStorage.setItem('online_token', token);
    }

    public getToken() {
        return localStorage.getItem('id_token');
    }

    public getOnlineToken() {
        return localStorage.getItem('online_token');
    }
    
    public decodeToken() {
        const token: any = this.getToken();
        const decoded: any = decode(token);

        return decoded;
    }

    public isTokenExpired(token: string) {
        try {
            const decoded: any = decode(token);
            if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
                return true;
            }
            
            return false;
        }
        catch (err) {
            return false;
        }
    }

    public getProfile() {
        return decode(this.getToken() || '');
    }
}


// WEBPACK FOOTER //
// ./src/Services/Auth/Auth.tsx